// 全局自定义指令

export default {
	'hover': {
		// css hover特效(字体颜色|背景颜色)
		bind: (el, binding) => {
			const styleObj = binding.value || {};
			if (Object.keys(styleObj).length) {
				Object.keys(styleObj).forEach(key => el['original_' + key] = el.style[key]);
				el.addEventListener('mouseover', function(event) {
					Object.keys(styleObj).forEach(key => el.style[key] = styleObj[key]);
				});
				el.addEventListener('mouseout', function(event) {
					Object.keys(styleObj).forEach(key => el.style[key] = el['original_' + key]);
				});
				el.addEventListener('touchstart', function(event) {
					Object.keys(styleObj).forEach(key => el.style[key] = styleObj[key]);
				});
				el.addEventListener('touchend', function(event) {
					Object.keys(styleObj).forEach(key => el.style[key] = el['original_' + key]);
				});
			}
		}
	}
}